import { render } from "./BaoCaoSanLocBenhKLNVaKSKDaGoi.vue?vue&type=template&id=231bcb7b&ts=true"
import script from "./BaoCaoSanLocBenhKLNVaKSKDaGoi.vue?vue&type=script&lang=ts"
export * from "./BaoCaoSanLocBenhKLNVaKSKDaGoi.vue?vue&type=script&lang=ts"

import "./BaoCaoSanLocBenhKLNVaKSKDaGoi.vue?vue&type=style&index=0&id=231bcb7b&lang=scss"

import exportComponent from "/Volumes/DATA/Project/WebsiteProject/CDC/BaoCao/CDC_FE/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__